import _ from 'lodash';
import log from './log';

// Functions for saving extension data to storage.
const css = 'color: #f08668; font-weight: bold; font-size: 12px';

function visits(newState) {
	// local
	log('%csave visits \n', css, newState.visits);
	window.localStorage.setItem('visits', JSON.stringify(newState.visits));
}

function lastVerification(newState) {
	// local
	log('%csave lastVerification \n', css, newState.lastVerification);
	window.localStorage.setItem('lastVerification', JSON.stringify(newState.lastVerification));
}

function allPets(newState) {
	// local
	log('%csave allPets \n', css, newState.allPets);
	window.localStorage.setItem('allPets', JSON.stringify(newState.allPets));
}

function activePet(newState) {
	// local
	const activePetAttributesToSave = {
		shuffle: newState.activePet.shuffle,
		active: {
			petType: newState.activePet.active.petType,
		},
	};

	log('%csave activePet \n', css, activePetAttributesToSave);
	window.localStorage.setItem('activePet', JSON.stringify(activePetAttributesToSave));
}

function collectedGoodies(newState) {
	// sync & local
	window.chrome.storage.sync.get('collectedGoodies', (storageResponse) => {

		const syncedGoodies = storageResponse.collectedGoodies;
		const reduxGoodies = newState.collectedGoodies.list;

		const cumulative = _.union(syncedGoodies, reduxGoodies);
		const cumulativeWhole = { newItems: _.get(newState.collectedGoodies, 'newItems'), list: cumulative };

		const newRedux = _.difference(reduxGoodies, syncedGoodies);
		const newSync = _.difference(syncedGoodies, reduxGoodies);

		// Case INIT - Sync isn't defined yet. Save storage to sync.
		if (_.isEmpty(storageResponse)) {
			log('CASE 0');
			// Save storage to sync.
			window.chrome.storage.sync.set({ 'collectedGoodies': newState.collectedGoodies.list }, () => { log('CASE 0: sync.set: ', newState.collectedGoodies.list); });
			// TRIP OVER
		}

		// Case 1 - Sync and Redux are equal. Just update local.
		else if (_.isEqual(syncedGoodies, reduxGoodies)) {
			log('CASE 1');
			// TRIP OVER
		}

		// Case 2 - Redux has new goodies. Update sync and local with cumulative.
		else if (!_.isEmpty(newRedux) && _.isEmpty(newSync)) {
			log('CASE 2');
			// save cumulativeWhole to sync
			window.chrome.storage.sync.set({ 'collectedGoodies': cumulative }, () => { log('CASE 2: sync.set: ', cumulative); });
			// TRIP OVER
		}

		// Case 3 - Sync has new goodies. Update Local with cumulative.
		else if (_.isEmpty(newRedux) && !_.isEmpty(newSync)) {
			log('CASE 3');
			// 2ND TRIP ON NEXT REFRESH -->
		}

		// Case 4 - Both Redux and Sync have new goodies.
		// Update local with cumulative. Sync will get set on second trip.
		else if (!_.isEmpty(newRedux) && !_.isEmpty(newSync)) {
			log('CASE 4');
			// 2ND TRIP ON NEXT REFRESH -->
		}

		log('%csave collectedGoodies \n', css, newState.collectedGoodies);
		// Save to local no matter what.
		window.localStorage.setItem('collectedGoodies', JSON.stringify(cumulativeWhole));
	});
}

function activeGoodies(newState) {
	// local
	log('%csave activeGoodies \n', css, newState.activeGoodies);
	window.localStorage.setItem('activeGoodies', JSON.stringify(newState.activeGoodies));
}

export default {
	visits,
	lastVerification,
	activePet,
	allPets,
	activeGoodies,
	collectedGoodies,
};



// WEBPACK FOOTER //
// ./src/utils/saveToStorage.js